import CountryFlag from "../../CountryFlag/CountryFlag";
import Typography from "@mui/material/Typography";
import React from "react";
import Spacer from "../../Spacer";
import {Link} from "react-router-dom";

const FlagButton = ({buttonText, buttonCountryName, queryCountryNameFilter, url}) => {
//      className="w-full md:w-72 lg:w-72 inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800"

    return (
        <Link
            to={`${url}/${queryCountryNameFilter}`}
            className="w-full md:w-72 lg:w-72 inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
            <CountryFlag countryName={buttonCountryName} height='40px' width='40px'/>
            <Spacer axis="horizontal" size={15}/>
            <Typography variant={"h6"} sx={{fontWeight: 400}}>
                {buttonText}
            </Typography>
        </Link>
    )
}

export default FlagButton